<!-- 经纪人-看板-总览 -->
<template>
  <div id="agentOverview">
    <!-- 头部数据更新时间模块 -->
    <headerUpdate></headerUpdate>
    <div class="invite-data-md">
      <div class="title">
        <!--商户-->
        <b-form-group class="find-middle trade-form" style="width: 400px" v-if="!disabledBroker">
          <label class="trade-form-title left">
            {{ $t("common.clientName") }}</label>
          <v-select style="display: inline-block" class="find-select"
            :style="{ marginLeft: lan == 'zh_CN' ? '40px' : '70px' }" v-model="brokerId" :options="brokerList"
            :disabled="disabledBroker">
            <div slot="no-options">{{ $t("common.noFind") }}</div>
          </v-select>
        </b-form-group>
      </div>
      <div class="invite-card-box">
        <ul>
          <li>
            <div class="num enNum" v-if="brokerInfo">
              {{ brokerInfo.inviteNum }}
            </div>
            <div class="text">
              <a id="tooltip-target-2" href="javascript:">
                <!-- 受邀用户数 -->
                {{ $t("lanV4.invitedUsers") }}
              </a>
              <b-tooltip target="tooltip-target-2" triggers="hover">
                <!-- 用户中通过邀请码注册的用户数； -->
                {{ $t("lanV4.invitedUsersTip") }}
              </b-tooltip>
            </div>
          </li>
          <li>
            <div class="num enNum" v-if="brokerInfo">
              {{ brokerInfo.allNum }}
            </div>
            <div class="text">
              <!-- 总用户数 -->
              {{ $t("lanV4.TotalNumberUsers") }}
            </div>
          </li>
          <li>
            <div class="num enNum" v-if="brokerInfo">
              {{ brokerInfo.coAgentNum }}
            </div>
            <div class="text">
              <!-- 合约经纪人数量 -->
              {{ $t("lanV4.contractBrokeNum") }}
            </div>
          </li>
          <li>
            <div class="num enNum" v-if="brokerInfo">
              {{ brokerInfo.allReturnAmount }}
            </div>
            <div class="text">
              <a id="tooltip-target-4" href="javascript:">
                <!--累计发放返佣(USDT) -->
                {{ $t("lanV4.commissionRebates") }}
              </a>
              <b-tooltip target="tooltip-target-4" triggers="hover">
                <!-- 发放给经纪人合约返佣的总和，非U币种按照统计时的汇率折算成USDT；-->
                {{ $t("lanV4.commissionRebatesTip") }}
              </b-tooltip>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col :md="24" :lg="12" class="chart-section">
        <b-card>
          <div class="md-header">
            <div class="title">
              <!-- 每日新增受邀用户数 -->
              {{ $t("lanV4.overInvitedUsers") }}
            </div>
            <!--时间段-->
            <div class="right">
              <b-form-group class="find-middle">
                <el-date-picker unlink-panels v-model="dateArray" type="daterange" range-separator="-"
                  :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                  value-format="yyyy-MM-dd" @change="handleChangeDate('inviteNum')" :clearable="false"
                  :pickerOptions="pickerOptionsTwo">
                </el-date-picker>
              </b-form-group>

              <!-- 导出数据 -->
              <div class="export" @click="exports('', 'inviteNum')">
                <!-- 导出数据 -->
                <svg class="icon icon-16" aria-hidden="true">
                  <use xlink:href="#icon-v4_6_h"></use>
                </svg>
                {{ $t("realStatistics.exportTxt") }}
              </div>
            </div>
          </div>
          <overInvitedUsersChart :loading="loading2" :loadingErr="loadingErr2" @onErrReset="getDayData('inviteNum')"
            :chartData="inviteNumChartData"></overInvitedUsersChart>
        </b-card>
      </el-col>
      <el-col :md="24" :lg="12" class="chart-section">
        <b-card>
          <div class="md-header">
            <div class="title">
              <!-- 每日新增用户数-->
              {{ $t("lanV4.newUsers") }}
            </div>
            <!--时间段-->
            <div class="right">
              <b-form-group class="find-middle">
                <el-date-picker unlink-panels v-model="dateArray2" type="daterange" range-separator="-"
                  :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                  value-format="yyyy-MM-dd" @change="handleChangeDate('userNum')" :clearable="false"
                  :pickerOptions="pickerOptionsTwo">
                </el-date-picker>
              </b-form-group>

              <!-- 导出数据 -->
              <div class="export" @click="exports('', 'userNum')">
                <!-- 导出数据 -->
                <svg class="icon icon-16" aria-hidden="true">
                  <use xlink:href="#icon-v4_6_h"></use>
                </svg>
                {{ $t("realStatistics.exportTxt") }}
              </div>
            </div>
          </div>
          <overInNewUsersChart :loading="loading3" :loadingErr="loadingErr3" @onErrReset="getDayData('userNum')"
            :chartData="userNumChartData"></overInNewUsersChart>
        </b-card>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="24" :lg="12" class="chart-section">
        <b-card>
          <div class="md-header">
            <div class="title">
              <!-- 每日新增合约经纪人 -->
              {{ $t("lanV4.overAddAgentUsers") }}
            </div>
            <!--时间段-->
            <div class="right">
              <b-form-group class="find-middle">
                <el-date-picker unlink-panels v-model="dateArray3" type="daterange" range-separator="-"
                  :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                  value-format="yyyy-MM-dd" @change="handleChangeDate('agentNum')" :clearable="false"
                  :pickerOptions="pickerOptionsTwo">
                </el-date-picker>
              </b-form-group>

              <!-- 导出数据 -->
              <div class="export" @click="exports('', 'agentNum')">
                <!-- 导出数据 -->
                <svg class="icon icon-16" aria-hidden="true">
                  <use xlink:href="#icon-v4_6_h"></use>
                </svg>
                {{ $t("realStatistics.exportTxt") }}
              </div>
            </div>
          </div>
          <overAddAgentUsersChart :loading="loading4" :loadingErr="loadingErr4" @onErrReset="getDayData('agentNum')"
            :chartData="agentNumChartData"></overAddAgentUsersChart>
        </b-card>
      </el-col>
      <el-col :md="24" :lg="12" class="chart-section">
        <b-card>
          <div class="md-header">
            <div class="title">
              <!-- 每日发放返佣(USDT)-->
              {{ $t("lanV4.overReturn") }}
            </div>
            <!--时间段-->
            <div class="right">
              <b-form-group class="find-middle">
                <el-date-picker unlink-panels v-model="dateArray4" type="daterange" range-separator="-"
                  :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                  value-format="yyyy-MM-dd" @change="handleChangeDate('bonusAmount')" :clearable="false"
                  :pickerOptions="pickerOptionsTwo">
                </el-date-picker>
              </b-form-group>

              <!-- 导出数据 -->
              <div class="export" @click="exports('', 'bonusAmount')">
                <!-- 导出数据 -->
                <svg class="icon icon-16" aria-hidden="true">
                  <use xlink:href="#icon-v4_6_h"></use>
                </svg>
                {{ $t("realStatistics.exportTxt") }}
              </div>
            </div>
          </div>
          <overReturnChart :loading="loading5" :loadingErr="loadingErr5" @onErrReset="getDayData('bonusAmount')"
            :chartData="bonusAmountChartData"></overReturnChart>
        </b-card>
      </el-col>
    </el-row>

    <!-- 导出10000条提示 -->
    <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
      no-close-on-backdrop id="code-modal">
      <div class="body-content">
        <div class="expor-number-tip">
          {{ $t("exportsModal.text2", { pagesTotal: pages.total, maxNum: exportNumLimit }) }}
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
          $t("common.cancel")
        }}</b-button>
        <b-button v-if="findType" class="coustom-btn" variant="primary" @click="exports('true', findType)"
          :class="!isexportIng ? 'lodingSattus' : ''">
          <template v-if="!isexportIng">
            {{ $t("common.exportIng") }}
          </template>
          <template v-else>
            <!-- 继续导出 -->
            {{ $t("exportsModal.text3") }}
          </template>
        </b-button>
        <b-button v-else class="coustom-btn" variant="primary" @click="exports('true', findType)"
          :class="!isexportIng ? 'lodingSattus' : ''">
          <template v-if="!isexportIng">
            {{ $t("common.exportIng") }}
          </template>
          <template v-else>
            <!-- 继续导出 -->
            {{ $t("exportsModal.text3") }}
          </template>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import commonMixin from "@/mixin/common/commonMixin";
import headerUpdate from "./components/headerUpdate.vue";
import overInvitedUsersChart from "./components/overInvitedUsersChart.vue";
import overInNewUsersChart from "./components/overInNewUsersChart.vue";
import overAddAgentUsersChart from "./components/overAddAgentUsersChart.vue";
import overReturnChart from "./components/overReturnChart.vue";
import { formatTimeDay } from "@/apis/newmethods";
export default {
  name: "agentOverview",
  mixins: [commonMixin],
  components: {
    headerUpdate,
    overInvitedUsersChart,
    overInNewUsersChart,
    overAddAgentUsersChart,
    overReturnChart
  },
  data() {
    return {
      brokerId: null,
      brokerList: [],
      brokerInfo: {}, //商户总览数据
      dateArray: [],
      dateArray2: [],
      dateArray3: [],
      dateArray4: [],
      //我的每日返佣数据
      returnAmountChartData: [],
      // 每日新增受邀用户数
      inviteNumChartData: [],
      // 每日新增用户数
      userNumChartData: [],
      // 每日新增合约经纪人
      agentNumChartData: [],
      // 每日发放返佣
      bonusAmountChartData: [],

      loading: true,
      loading2: false,
      loadingErr2: false,
      loading3: false,
      loadingErr3: false,
      loading4: false,
      loadingErr4: false,
      loading5: false,
      loadingErr5: false,
      beginDate: null,
      endDate: null,
      dateType: null,
      lateDateval: "", //最近时间值
      findType: null,
      // 当天之后的时间无法选择
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > window.Date.now();
        },
      },
      // 某个日期之前的时间无法选择
      pickerOptionsTwo: {
        disabledDate(time) {
          return time.getTime() < new Date('2024-05-05').getTime() || time.getTime() > window.Date.now() - 8.64e7;
        }
      },
      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0, // 总页数
      },
    };
  },
  computed: {
    dateList() {
      return [
        {
          label: this.$t("realStatistics.dateArr[1]"), //近1月
          value: 1,
        },
      ];
    },
  },
  watch: {
    brokerId(v) {
      this.getData();
      this.getDayData('inviteNum') //每日新增受邀用户数
      this.getDayData('userNum') //每日新增用户数
      this.getDayData('agentNum') //每日新增合约经纪人
      this.getDayData('bonusAmount') //每日发放返佣:
    },
    lateDateval(val) {
      this.dateType = null;
      this.lateDateval = val;
      this.handleLateChange();
    },
  },
  created() {
    this.lateDateval = this.dateList[0];
    this.handleLateChange();
    this.getBrokerList();
    this.getDayData('inviteNum') //每日新增受邀用户数
    this.getDayData('userNum') //每日新增用户数
    this.getDayData('agentNum') //每日新增合约经纪人
    this.getDayData('bonusAmount') //每日发放返佣:
  },
  methods: {
    // 获取商户列表
    getBrokerList() {
      this.$http({
        url: this.$store.state.url.common.getBrokerList,
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          if (this.roleType === 1) {
            arr.push({ label: this.$t("common.all"), value: null });
          }
          if (data.length) {
            data.map((item) => {
              arr.push({ label: item.brokerName, value: item.id });
            });
            this.brokerList = arr;
            this.brokerId = arr[0];
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 选择时间
    handleChangeDate(findType) {
      if (findType === 'inviteNum') {
        this.beginDate = this.dateArray[0];
        this.endDate = this.dateArray[1];
      }
      if (findType === 'userNum') {
        this.beginDate = this.dateArray2[0];
        this.endDate = this.dateArray2[1];
      }
      if (findType === 'agentNum') {
        this.beginDate = this.dateArray3[0];
        this.endDate = this.dateArray3[1];
      }
      if (findType === 'bonusAmount') {
        this.beginDate = this.dateArray4[0];
        this.endDate = this.dateArray4[1];
      }

      if (findType) {
        this.getDayData(findType);
      }

    },
    handleLateChange() {
      if (this.lateDateval.value === 1) {
        this.getLastMonthOne();
      }
    },
    // 获取数据列表
    getData() {
      const paramsData = {
        companyId: this.brokerId ? this.brokerId.value : undefined,
      };
      this.$http({
        url: this.$store.state.url.agent.index,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          this.brokerInfo = data.brokerInfo ? data.brokerInfo : {};
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 获取每日图表数据
    getDayData(findType) {
      this.handleOpenLoading(findType);
      const paramsData = {
        isExport: 0, //0 查询 1导出
        startTime: this.dateArray
          ? new window.Date(this.beginDate).getTime()
          : null,
        endTime: this.dateArray
          ? new window.Date(this.endDate).getTime()
          : null,
        type: findType,
        companyId: this.brokerId ? this.brokerId.value : undefined,
      };
      this.$http({
        url: this.$store.state.url.agent.overview,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      })
        .then(({ data, code, msg }) => {

          this.loading2 = false;
          this.loading3 = false;
          this.loading4 = false;
          this.loading5 = false;
          if (data && code.toString() === "0") {
            let arr = [];
            // 每日新增受邀用户数
            if (findType === "inviteNum") {
              this.inviteNumChartData = [];
              if (data && data.pageInfo && data.pageInfo.rows) {
                data.pageInfo.rows.forEach((item) => {
                  arr.push({
                    timestamp: item.timestamp ? formatTimeDay(item.timestamp) : "",
                    amount: item.count,
                  });
                });
                this.inviteNumChartData = arr;

              }
            }
            // 每日新增用户数
            if (findType === "userNum") {
              this.userNumChartData = [];
              if (data && data.pageInfo && data.pageInfo.rows) {
                data.pageInfo.rows.forEach((item) => {
                  arr.push({
                    timestamp: item.timestamp ? formatTimeDay(item.timestamp) : "",
                    amount: item.count,
                  });
                });
                this.userNumChartData = arr;
              }
            }
            // 每日新增合约经纪人
            if (findType === "agentNum") {
              this.agentNumChartData = [];
              if (data && data.pageInfo && data.pageInfo.rows) {
                data.pageInfo.rows.forEach((item) => {
                  arr.push({
                    timestamp: item.timestamp ? formatTimeDay(item.timestamp) : "",
                    amount: item.count,
                  });
                });
                this.agentNumChartData = arr;
              }
            }
            // 每日发放返佣
            if (findType === "bonusAmount") {
              this.bonusAmountChartData = [];
              if (data && data.pageInfo && data.pageInfo.rows) {
                data.pageInfo.rows.forEach((item) => {
                  arr.push({
                    timestamp: item.timestamp ? formatTimeDay(item.timestamp) : "",
                    amount: item.bonusAmount,
                  });
                });
                this.bonusAmountChartData = arr;
              }
            }
            this.pages.total = data.pageInfo.total;
          } else {
            this.handleCloseLoading();
            this.handleOpenError(findType);
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.handleCloseLoading();
          this.handleOpenError(findType);
        });
    },
    // 打开loading
    handleOpenLoading(findType) {
      if (
        findType === "inviteNum"
      ) {
        this.loading2 = true;
      }
      if (findType === "userNum") {
        this.loading3 = true;
      }
      if (findType === "agentNum") {
        this.loading4 = true;
      }
      if (findType === "bonusAmount") {
        this.loading5 = true;
      }
    },
    // 关闭图表loading
    handleCloseLoading() {
      this.loading2 = false;
      this.loading3 = false;
      this.loading4 = false;
      this.loading5 = false;
    },
    // 打开错误重试
    handleOpenError(findType) {
      if (
        findType === "inviteNum"
      ) {
        this.loadingErr2 = true;
      }
      if (findType === "userNum") {
        this.loadingErr3 = true;
      }
      if (findType === "agentNum") {
        this.loadingErr4 = true;
      }
      if (findType === "bonusAmount") {
        this.loadingErr5 = true;
      }
    },
    // 导出
    exports(istrue, findType) {
      if (
        istrue !== "true" &&
        this.pages.total &&
        Number(this.pages.total) > this.exportNumLimit
      ) {
        this.exportsModalShow = true;
        this.findType = findType


      } else {
        if (!this.isexportIng) return;
        this.isexportIng = false;
        if (findType === 'inviteNum') {
          this.beginDate = this.dateArray[0];
          this.endDate = this.dateArray[1];
        }
        if (findType === 'userNum') {
          this.beginDate = this.dateArray2[0];
          this.endDate = this.dateArray2[1];
        }
        if (findType === 'agentNum') {
          this.beginDate = this.dateArray3[0];
          this.endDate = this.dateArray3[1];
        }
        if (findType === 'bonusAmount') {
          this.beginDate = this.dateArray4[0];
          this.endDate = this.dateArray4[1];
        }
        const paramsData = {
          startTime: this.dateArray
            ? new window.Date(this.beginDate).getTime()
            : null,
          endTime: this.dateArray
            ? new window.Date(this.endDate).getTime()
            : null,
          isExport: 1, //0 查询  1导出
          pageNum: this.pages.page,
          pageSize: this.exportNumLimit,
          type: findType,
          companyId: this.brokerId ? this.brokerId.value : undefined,
        };
        this.outExcel(
          this.$store.state.url.agent.overview,
          paramsData,
          "increment-api"
        ).then((datas) => {
          setTimeout(() => {
            this.isexportIng = true;
          }, 500);
          if (datas.code === "0") {
            this.$bus.$emit("alert", {
              type: "success",
              message: this.$t("common.exportSuccess"),
            }); // 导出成功
          } else {
            this.$bus.$emit("alert", {
              type: "error",
              message: this.$t("common.exportError"),
            }); // 导出失败
          }
        });
      }
    },
    // 最近一月
    getLastMonthOne() {
      var end = new window.Date(new window.Date() - 1000 * 60 * 60 * 24);
      var year = end.getFullYear();
      var month = end.getMonth() + 1; //0-11表示1-12月
      var day = end.getDate();
      var dateObj = {};
      dateObj.end = year + "-" + month + "-" + day;
      var endMonthDay = new window.Date(year, month, 0).getDate(); //当前月的总天数
      if (month - 1 <= 0) {
        //如果是1月，年数往前推一年<br>
        dateObj.start = year - 1 + "-" + 12 + "-" + day;
      } else {
        var startMonthDay = new window.Date(
          year,
          parseInt(month) - 1,
          0
        ).getDate();
        if (startMonthDay < day) {
          //1个月前所在月的总天数小于现在的天日期
          if (day < endMonthDay) {
            //当前天日期小于当前月总天数
            dateObj.start =
              year +
              "-" +
              (month - 1) +
              "-" +
              (startMonthDay - (endMonthDay - day));
          } else {
            dateObj.start = year + "-" + (month - 1) + "-" + startMonthDay;
          }
        } else {
          dateObj.start = year + "-" + (month - 1) + "-" + day;
        }
      }
      this.beginDate = new window.Date(dateObj.start.replace(/-/g, "/"));
      this.endDate = new window.Date(dateObj.end.replace(/-/g, "/"));
      this.dateType = 1;
      this.dateArray = [this.beginDate, this.endDate];
      this.dateArray2 = [this.beginDate, this.endDate];
      this.dateArray3 = [this.beginDate, this.endDate];
      this.dateArray4 = [this.beginDate, this.endDate];
    },
    onReset() {
      this.exportsModalShow = false;
    },
  },
};
</script>

<style lang="scss">
.agent-params {
  .el-popover__title {
    text-align: left;
  }
}

.param-content {
  position: relative;

  .close {
    width: 12px;
    position: absolute;
    top: -30px;
    right: 0px;
    cursor: pointer;
  }

  ul {
    li {
      display: flex;
      justify-content: space-between;

      .left {
        font-size: 12px;
        color: #93979d;
      }

      .right {
        font-size: 14px;
        color: #93979d;
        font-family: "HarmonyOS-Regular" !important;
      }
    }
  }
}


#agentOverview {

  .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 230px !important;
  }

  .el-date-editor .el-range-separator {
    margin-left: 5px !important;
    margin-right: 7px !important;
    position: relative !important;
    top: -3px !important;
  }
}
</style>
<style lang="scss" scoped>
#agentOverview {
  min-width: 1310px;

  .invite-data-md {
    width: 100%;
    border-radius: 16px;
    background: #fff;
    // height: 142px;
    margin-top: 10px;
    padding: 24px 24px 12px 24px;
    line-height: 1;
    // overflow: hidden;
    margin-bottom: 10px;

    .title {
      .trade-form {
        position: relative;
      }

      .trade-form-title {
        color: #303133;
        font-family: HarmonyOS-Regular;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        margin-right: 10px;
        position: absolute;
        left: 0px;
        top: 6px;
      }
    }

    .invite-card-box {
      margin-top: 10px;

      ul {
        display: flex;

        li {
          margin-right: 110px;

          &:last-child {
            margin-right: 0px;
          }

          .num {
            color: #23272e;
            font-family: HarmonyOS-Bold !important;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 22px;
          }

          .text {
            color: #8b909a;
            font-family: HarmonyOS-Medium;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin-top: 8px;

            a {
              color: #93979d;
              text-decoration: none;
              border-bottom: 1px dotted;
            }
          }
        }
      }
    }
  }

  .chart-section {
    position: relative;
    margin-bottom: 20px;
    border-radius: 8px !important;

    .card {
      border-radius: 16px !important;
    }

    .card-body {
      border-radius: 16px !important;
      padding: 32px 30px 24px 30px !important;
    }

    .md-header {
      display: flex;
      justify-content: space-between;

      .right {
        display: flex;
        margin-top: -8px;
      }

      .title {
        color: #24324C;
        font-family: "HarmonyOS-Medium" !important;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }

    .export {
      font-size: 14px;
      font-family: "HarmonyOS-Medium" !important;
      cursor: pointer;
      height: 32px;
      line-height: 32px;
      padding: 0 16px;
      background: #f3f4f8;
      border-radius: 4px;
      color: #24324c;
      white-space: nowrap;

      .icon-16 {
        position: relative;
        top: 1px;
      }
    }
  }
}
</style>